<template lang="pug">
InputWithIconSlot(
  :value='value' :type='type' :placeholder='placeholder'
  :width='width' :rows='rows' :disabled='disabled'
  :autocomplete='autocomplete'

  :isLoading='isLoading'
  @input='countDownAndEmit'
)
  template(v-if='isLoading === true')
    //- type='grow'
    LoadingIndicator.mx-auto.pt-1(
      :sm='true'
      style='color: #B5B5B7'
    )
  template(v-else)
    i.fa.fa-search
</template>

<script>
export default {
  props: {
    value: { default: '' },
    type: { default: 'text' },
    placeholder: { default: 'ระบุ' },
    width: { default: '250px' },
    rows: { default: 3 },
    disabled: { default: false },
    autocomplete: { default: '' },

    delayInterval: { default: 1000 },
    isLoading: { default: false },
  },
  data: () => ({
    timeout: null,
  }),
  methods: {
    countDownAndEmit(e) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.$emit('input', e);
        // alert(JSON.stringify(e));
        // console.log('yeah!!');
      }, this.delayInterval);
    },
  },
};
</script>

<style lang="scss">
// .custom-search-box {}
</style>
